
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import RoundSelect from '@/components/molecules/RoundSelect.vue'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import CurriculumMapUnitList from '@/components/organisms/manage/proofread/CurriculumMapUnitList.vue'
import { SelectItem } from '@/models/SelectItem'
import { ProofreadLearningMapUnit } from '@/models/manage/ProofreadList'

/**
 * 校正画面-単元一覧(知識マップ)
 */
@Component({
  components: {
    RoundSelect,
    ManageSidemenuLayout,
    PanelFrame,
    CurriculumMapUnitList,
  },
})
export default class ProofreadLearningMapUnits extends Vue {
  /** 教科フィルター */
  @Ref()
  subjectFilter!: RoundSelect

  /** 知識マップフィルター */
  @Ref()
  mapFilter!: RoundSelect

  /** 塾管理権限の画面か否か */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限の画面か否か(未使用) */
  @Prop({ default: false })
  private isAdmin!: boolean

  /** 教科一覧 */
  @Prop()
  private subjectList!: SelectItem[]

  /** 教科の初期選択値 */
  @Prop()
  private defaultSubjectCode!: string

  /** 知識マップ一覧 */
  @Prop()
  private filterMapList!: SelectItem[]

  /** 知識マップの初期選択値 */
  @Prop()
  private defaultMapId!: string

  /** 単元一覧 */
  @Prop()
  private unitList!: ProofreadLearningMapUnit[]

  /** 単元選択時の処理 */
  @Prop()
  private eventSelectUnit!: (id: number) => Promise<void>

  /** 教科変更時の処理 */
  @Prop()
  private eventChangeSubject!: () => Promise<void>

  /** 知識マップ変更時の処理 */
  @Prop()
  private eventChangeMap!: () => Promise<void>

  /**
   * 選択中の教科コード
   *
   * @returns 教科コード
   */
  public get subjectCode(): string | null {
    if (!this.subjectFilter) {
      return null
    }
    return this.subjectFilter.selectedValue()
  }

  /**
   * 選択中の知識マップID
   *
   * @returns 知識マップID
   */
  public get mapId(): number | null {
    if (!this.mapFilter) {
      return null
    }
    return Number(this.mapFilter.selectedValue())
  }
}
